import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faWordpress, 
  faShopify, 
  faWebflow, 
  faWix, 
  faGoogle
} from '@fortawesome/free-brands-svg-icons';
import { 
  faGlobe, 
  faChartLine,
  faGhost,
  faMagnifyingGlass,
  faRocket
} from '@fortawesome/free-solid-svg-icons';
import { ReactNode } from 'react';

type IconMap = {
  [key: string]: ReactNode;
};

// CMS Icons
export const cmsIcons: IconMap = {
  WordPress: <FontAwesomeIcon icon={faWordpress} className="h-6 w-6" />,
  Shopify: <FontAwesomeIcon icon={faShopify} className="h-6 w-6" />,
  Webflow: <FontAwesomeIcon icon={faWebflow} className="h-6 w-6" />,
  Wix: <FontAwesomeIcon icon={faWix} className="h-6 w-6" />,
  Ghost: <FontAwesomeIcon icon={faGhost} className="h-6 w-6" />,
  Sanity: <FontAwesomeIcon icon={faGlobe} className="h-6 w-6" />,
  Astro: <FontAwesomeIcon icon={faRocket} className="h-6 w-6" />,
  Custom: <FontAwesomeIcon icon={faGlobe} className="h-6 w-6" />
};

// Analytics Icons
export const analyticsIcons: IconMap = {
  'Google Analytics': <FontAwesomeIcon icon={faGoogle} className="h-6 w-6" />,
  'Plausible Analytics': <FontAwesomeIcon icon={faChartLine} className="h-6 w-6" />
};

// Webmaster Icons
export const webmasterIcons: IconMap = {
  'Google Search Console': <FontAwesomeIcon icon={faGoogle} className="h-6 w-6" />,
  'Bing Webmaster': <FontAwesomeIcon icon={faMagnifyingGlass} className="h-6 w-6" />
}; 